module.exports = __webpack_public_path__ + "static/media/styledmenu-close_Hover.381cce06.svg";